import { Component, Input, OnInit } from '@angular/core';
import { LMBuilderModel } from "@components/builder/services/lm-builder-model.service";

@Component({
  selector:    'lm-builder-property-panel',
  standalone: false,
  templateUrl: './lm-builder-property-panel.component.html',
  styleUrl: './lm-builder-property-panel.component.scss',
})

export class LMBuilderPropertyPanelComponent implements OnInit {
  @Input() spec!: LMListPSpec;

  allowSharing = false;
  allowReportCategorization = false;
  allowRestrictedActions = false;

  constructor(
      private lmBuilderModel: LMBuilderModel,
  ) {
      // no-op
  }

  ngOnInit(): void {
    this.initialize();
  }

  private initialize() {
    this.allowRestrictedActions = this.lmBuilderModel.allowRestrictedActions();

    if (this.spec?.userFolder) {
      this.allowSharing = this.lmBuilderModel.allowSharing();
      this.allowReportCategorization = this.spec.formReport != undefined;
      this.allowRestrictedActions = this.lmBuilderModel.allowRestrictedActions();
    }
  }
}
